import { isNavigationFailure, NavigationFailureType, type NavigationFailure } from 'vue-router';

const NAVIGATION_FAILURE_MASK: NavigationFailureType =
  NavigationFailureType.aborted | NavigationFailureType.cancelled | NavigationFailureType.duplicated;

/**
 * router.push()/router.replace() resolve (never reject) with a NavigationFailure when a
 * guard cancels the navigation — that failure is silent (no thrown error, no URL change)
 * unless something inspects the resolved value, which none of the fire-and-forget calls in
 * the training edit flow used to do.
 */
export function logNavigationFailure(source: string, navigationResult: NavigationFailure | void | undefined): void {
  if (!navigationResult || !isNavigationFailure(navigationResult, NAVIGATION_FAILURE_MASK)) return;

  console.error(`[${source}] navegação cancelada`, {
    type: NavigationFailureType[navigationResult.type],
    to: navigationResult.to,
    from: navigationResult.from,
  });
}
